import React from 'react'
import News from './News' 
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = { 
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,  
    arrows:false,
    adaptiveHeight: true, 
  };
  return (
   <>
   <div className="slider-sec"> 
   <div className='news'>
    <News />
   </div>
   <div className='homeslider'>
    <Slider {...settings}> 
       <div className="item">
           <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider0.jpg" alt="CCSDH" className="img-fluid" />              
       </div>
        <div className="item">
          <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider1.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
          <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider2.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider3.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider4.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider5.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider6.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider7.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider8.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider9.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider10.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider11.jpg" alt="CCSDH" className="img-fluid" />              
        </div>
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider12.jpg" alt="CCSDH" className="img-fluid" />              
        </div> 
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider13.jpg" alt="CCSDH" className="img-fluid" />              
        </div> 
        <div className="item">
            <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/slider14.jpg" alt="CCSDH" className="img-fluid" />              
        </div> 
   </Slider>
   </div> 
   </div>
   </>
  )
}

export default HomeSlider
